import { observer } from 'mobx-react';
import * as React from 'react';
import { FieldFor, findField, FormField } from '../../Types';

interface Props<K extends FormField['kind']> {
  kind: K;
  name: string;
  fields: ReadonlyArray<FormField>;
  children: (field: FieldFor<K>) => React.ReactNode;
}

@observer
class WithField<K extends FormField['kind']> extends React.Component<Props<K>> {
  render() {
    const { kind, name, fields, children } = this.props;
    return findField(name, kind, fields)
      .map(children)
      .getOrElse(() => <></>);
  }
}

export default WithField;
